import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    UPDATE_PATIENT_DETAIL,
    updatePatientDetailFail,
    updatePatientDetailSuccess
} from '../action/updatePatientDetailAction'

// api 
import updatePatientDetailApi from '../api/updatePatientDetailApi'

export function* updatePatientDetailSaga(action) {
    try {
        const response = yield call(() => updatePatientDetailApi(action.params))
        console.log("upsaga",response)
        if (response.data.statusCode === 200) {
            console.log("zeeshan")
            yield put(updatePatientDetailSuccess(response, action))
        } else {
            console.log("khan")
            yield put(updatePatientDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(updatePatientDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(UPDATE_PATIENT_DETAIL, updatePatientDetailSaga)
}